<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="采集监管码" @click-left="onClickLeft" @click-right="goIndex()" />
    <van-cell-group>
      <van-field ref="barcode" v-model="barcode" autofocus="true" label="条码" left-icon="photograph" placeholder="请扫描条码" @keyup="scan" />
    </van-cell-group>
    <van-radio-group v-model="radio" direction="horizontal" @change="radioChange">
      <van-radio name="1" radio-size="30px" span="10">中包装</van-radio>
      <van-radio name="2" span="10">小包装</van-radio>
    </van-radio-group>
    <van-field v-model="collectNumber" label="采集数" name="采集数" readonly />
    <vxe-table
      ref="tasks"
      :data="list"
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :scroll-x="{enabled: true}"
      align="center"
      border
      :loading="loading"
      round
      show-header-overflow
      show-overflow
      size="mini"
      stripe
      @dblclick="handleCheck">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="no" title="监管码" />
    </vxe-table>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="12">
            <van-button :loading="loading" block round style="margin: 8px;" type="primary" @click="save">保存</van-button>
          </van-col>
          <van-col span="12">
            <van-button :loading="loading" block round style="margin: 8px;" type="info" @click="remove">删除</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import api from '@/api'
import debounce from 'lodash/debounce'
import { findOne, post } from '@/api/Api'
import { Toast } from 'vant'
import { getSupervisionBarcode, getUser } from '@/pdaView/utils'

export default {
    data() {
      return {
        loading: false,
        username: getUser().name,
        parent: this.$route.params.parent,
        command: this.$route.params.command,
        pack: this.$route.params.pack,
        selectedRowKeys: [],
        selectedRows: {},
        collectNumber: null,
        barcode: null,
        radio: '2',
        list: []
      }
    },
    created: function() {
      this.search('1')
    },
    methods: {
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      onClickLeft() {
        this.$router.push({ name: this.parent, params: { pickingOrder_id: this.$route.params.arr.pickingOrder.id } })
      },
      radioChange(i) {
        this.radio = i
        this.search(i)
        console.log(this.radio)
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.handleCheck()
      },
      handleCheck(record, index) {
        return {
          on: {
            click: () => {
              this.selectedRowKeys = [index]
              this.selectedRows = record
            }
          }
        }
      },
      scan: debounce(function(data) {
        if ([13].includes(data.keyCode)) {
          const value = _.trim(data.target.value)
          this.save(value)
        }
      }, 300),
      search(radio) {
        const args = {
          'command.id': this.command.id
        }
        findOne('supervisionBarcodeShipmentFactory', args).then(res => {
          if (res.success) {
            let list = getSupervisionBarcode(this.command.actualQuantity, res.result, this.pack.innerFactor, '')
            if (radio === '2') {
              console.log(list)
              this.list = list.small
              this.ScannedNumber = list.smallScannedNumber
              this.SweptNumber = list.smallSweptNumber
              this.collectNumber = list.smallSweptNumber + '/' + list.smallScannedNumber
            } else if (radio === '1') {
              this.ScannedNumber = list.middleScannedNumber
              this.SweptNumber = list.middleSweptNumber
              this.list = list.middle
              this.collectNumber = list.middleSweptNumber + '/' + list.middleScannedNumber
            }
          }
        })
      },
      save() {
        if (this.SweptNumber >= this.ScannedNumber) {
          this.barcode = null
          Toast('采集数不能大于监管码数')
          return
        }
        this.loading = true
        const args = {
          operationType: 2,
          id: this.commandId,
          largePack: [],
          mediumPack: this.radio === '1' ? [this.barcode] : [],
          smallPack: this.radio === '2' ? [this.barcode] : []
        }
        post(api.supervisingSaveAll, {}, args).then(res => {
          if (res.success) {
            Toast('保存成功！')
            this.barcode = null
            this.search(this.radio)
          }
        }).finally(() => this.loading = false)
      },
      remove() {
        if (!this.selectedRows) {
          Toast('请选择一行数据')
          return
        }
        this.loading = true
        let data = this.selectedRows
        post(api.supervisingDelete, {}, { no: data.no }).then(res => {
          console.log(res)
          if (res.success) {
            Toast('删除成功')
            this.search(this.radio)
          }
        }).finally(() => this.loading = false)
      }
    },
    beforeRouteLeave(to, from, next) {
// 导航离开当前路由的时候被调用，this可以被访问到
//     console.log(this) // 可以访问this
      console.log(to)
      console.log(from)
      console.log('beforeRouteLeave')
      next()
    }
  }
</script>